import mitt from 'mitt';
import { clientSideTokenProvider } from './token-provider';
import { Authenticator } from './authenticator';

export class AuthClient {
  userProvider;
  authenticator;
  emitter;
  logger;
  _user = false;
  _promise = null;

  constructor(authClientConfiguration) {
    this.userProvider = authClientConfiguration.userProvider;
    this.authenticator = new Authenticator({
      customerWebsiteBaseUrl: authClientConfiguration.customerWebsiteBaseUrl,
      tokenProvider: authClientConfiguration.tokenProvider || clientSideTokenProvider,
    });
    this.emitter = authClientConfiguration.emitter || mitt();
    this.logger = console;
  }

  async user(forceLoad = false) {
    this.logger.info(`AuthClient:user called forceLoad: ${forceLoad}`);
    if (!forceLoad && this._promise instanceof Promise) {
      return this._promise;
    } else if (forceLoad || !this._user) {
      this._promise = this.fetchProfile()
        .then((user) => {
          if (user) {
            this._user = user;
          }
          return user;
        })
        .catch((error) => {
          this.logger.error('AuthClient.user(): failed to fetch user', error);
          return false;
        });
      return this._promise;
    }
    return Promise.resolve(this._user);
  }

  async fetchProfile() {
    this.logger.info(`AuthClient:fetchProfile called...`);
    const authentication = await this.authenticator.getAuthentication();
    if (authentication.idToken) {
      return this.userProvider.getUser(authentication.customerId, authentication.idToken);
    }
    return false;
  }

  async isAuthenticated() {
    this.logger.info(`AuthClient:isAuthenticated called...`);
    try {
      await this.authenticator.getAuthentication();
      return true;
    } catch {
      return false;
    }
  }

  isTrusted() {
    this.logger.info(`AuthClient:isTrusted called...`);
    if (this._user instanceof Promise) {
      return false;
    }
    return (
      this._user && this._user.trusted && this._user.status_sms === 'verified' && this._user.status_email === 'verified'
    );
  }

  async grant({ returnUser = false, redirectMessage = '' } = {}) {
    this.logger.info(`AuthClient:grant called... returnUser: ${returnUser}, redirectMessage: ${redirectMessage}`);
    if (this._user instanceof Promise) {
      return { success: false };
    }
    return { success: await this.isAuthenticated() };
  }
}
